import { render } from "./PaintingCard.vue?vue&type=template&id=6afaa04c&scoped=true"
import script from "./PaintingCard.vue?vue&type=script&lang=js"
export * from "./PaintingCard.vue?vue&type=script&lang=js"

import "./PaintingCard.vue?vue&type=style&index=0&id=6afaa04c&scoped=true&lang=css"

import exportComponent from "D:\\Code_projects\\maria_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afaa04c"]])

export default __exports__